module.exports = __webpack_public_path__ + "static/amazon-67bb7dc6b77a3c03f86d835ccbab8abe.jpg";